import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { InputField, TextAreaField } from '../inputs/standard';
import ErrorList from './ErrorList';
import AuthService from '../services/api/auth';
import Calendar from '../components/Calendar';
import Helper from '../helpers';
const countries = AuthService.getCountries();

let PersonalDetailsForm = React.forwardRef((props, ref) => {
    const { handleSubmit } = props;
    let errors = Object.keys(props.errors).map((key, i) => {
        return window.VULOG_TRANSLATE(`${key} ${props.errors[key]}`);
    });

    if (props.error) {
        errors.push(window.VULOG_TRANSLATE(props.error));
    }

    const inputClass = (name, customClass) =>
        Helper.isFieldRequired(name)
            ? `blue small col-4 mb-0 isRequired ${customClass}`
            : `blue small col-4 mb-0 ${customClass}`;

    const states = AuthService.getStates(props.Country);

    return (
        <form onSubmit={handleSubmit} ref={ref}>
            {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}

            {window.VULOG_CONFIG.STEPS.map(i => i.title).indexOf('DL_CHECK') === -1 && (
                <Fragment>
                    <div className="form-row mb-2">
                        <label htmlFor="first-name" className={inputClass('GivenName')}>
                            {window.VULOG_TRANSLATE('First Name')}
                        </label>
                        <div className="col">
                            <Field
                                component={InputField}
                                name={'GivenName'}
                                type="text"
                                className="form-control"
                                id="first-name"
                            />
                        </div>
                    </div>
                    <div className="form-row mb-2">
                        <label htmlFor="last-name" className={inputClass('Surname')}>
                            {window.VULOG_TRANSLATE('Last Name')}
                        </label>
                        <div className="col">
                            <Field component={InputField} name={'Surname'} className="form-control" id="last-name" />
                        </div>
                    </div>

                    <div className="form-row mb-2">
                        <label htmlFor="birth-date" className={inputClass('BirthDate')}>
                            {window.VULOG_TRANSLATE('Birth Date')}
                        </label>
                        <div className="col">
                            <Field
                                name="BirthDate"
                                disableFuture
                                isUsFormat={window.VULOG_CONFIG.US_DATE_FORMAT}
                                component={Calendar}
                            />
                        </div>
                    </div>
                </Fragment>
            )}

            <div className="form-row mb-2">
                <label htmlFor="gender" className={inputClass('Sex', 'align-self-start line30')}>
                    {window.VULOG_TRANSLATE('Gender')}
                </label>
                <div className="col">
                    <label className="d-flex flex-row justify-content-start mb-0">
                        <Field name="Sex" component="input" type="radio" value="M" className="mt-auto mb-auto mr-2" />
                        {window.VULOG_TRANSLATE('Male')}
                    </label>
                    <label className="d-flex flex-row justify-content-start mb-0">
                        <Field name="Sex" component="input" type="radio" value="F" className="mt-auto mb-auto mr-2" />
                        {window.VULOG_TRANSLATE('Female')}
                    </label>
                    {window.VULOG_CONFIG.STEPS.map(i => i.title).indexOf('FC') === -1 && (
                        <label className="d-flex flex-row justify-content-start mb-0">
                            <Field
                                name="Sex"
                                component="input"
                                type="radio"
                                value=""
                                className="mt-auto mb-auto mr-2"
                            />
                            {window.VULOG_TRANSLATE('Preffer Not To Say')}
                        </label>
                    )}
                </div>
            </div>
            <div className="form-row mb-2">
                <label htmlFor="issuing-country" className={inputClass('Country')}>
                    {window.VULOG_TRANSLATE('Country')}
                </label>
                <div className="col">
                    <Field name={'Country'} component={'select'} className={'form-control'}>
                        {countries.map(country => (
                            <option key={country.value} value={country.value}>
                                {country.label}
                            </option>
                        ))}
                    </Field>
                </div>
            </div>
            {(props.Country === 'USA' || props.Country === 'CAN') && (
                <div className="form-row mb-2">
                    <label htmlFor="issuing-state" className="blue small col-4 mb-0">
                        {window.VULOG_TRANSLATE('State')}
                    </label>
                    <div className="col">
                        <Field name={'IssuingStateCode'} component={'select'} className={'form-control'}>
                            {states.map(state => (
                                <option key={state.value} value={state.value}>
                                    {state.label}
                                </option>
                            ))}
                        </Field>
                    </div>
                </div>
            )}
            {!window.VULOG_CONFIG.IS_CITY_FIELD_HIDDEN && (
                <div className="form-row mb-2">
                    <label htmlFor="city" className={inputClass('AddressCity')}>
                        {window.VULOG_TRANSLATE('City')}
                    </label>
                    <div className="col">
                        <Field component={InputField} name={'AddressCity'} className="form-control" id="AddressCity" />
                    </div>
                </div>
            )}
            <div className="form-row mb-2">
                <label htmlFor="address" className={inputClass('Address')}>
                    {window.VULOG_TRANSLATE('Address')}
                </label>
                <div className="col">
                    <Field
                        component={TextAreaField}
                        autoComplete={window.VULOG_CONFIG.HIDDEN_ADDRESS && 'nope'}
                        name={'Address'}
                        rows={4}
                        className="form-control"
                        id="address"
                    />
                </div>
            </div>
            {window.VULOG_CONFIG.REQUIRED_PERSONAL_DETAILS_FIELDS.includes('PostalCode') ? (
                <div className="form-row mb-2">
                    <label htmlFor="PostalCode" className={inputClass('PostalCode')}>
                        {window.VULOG_TRANSLATE('PostalCode')}
                    </label>
                    <div className="col">
                        <Field component={InputField} name={'PostalCode'} className="form-control" id="PostalCode" />
                    </div>
                </div>
            ) : null}

            {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
        </form>
    );
});

const selector = formValueSelector('personal-details');
PersonalDetailsForm = connect(
    state => ({
        // can select values individually
        Country: selector(state, 'Country'),
    }),
    null,
    null,
    { forwardRef: true }
)(PersonalDetailsForm);
PersonalDetailsForm = reduxForm({
    // a unique name for the form
    form: 'personal-details',
})(PersonalDetailsForm);

export default PersonalDetailsForm;
